import React, { FC } from 'react';

import { LocalizedAttribute } from '~/core/types';

import { PanelBroadcast } from '../../../../types';

import ListedBroadcaster from './components/listedBroadcaster/ListedBroadcaster';
import OtherCountriesPanel from './components/otherCountriesPanel/OtherCountriesPanel';

type BroadcastProps = {
    broadcast: PanelBroadcast;
    description?: LocalizedAttribute;
    isOtherCountriesPanel: boolean;
};

const Broadcast: FC<BroadcastProps> = ({ broadcast, description, isOtherCountriesPanel }: BroadcastProps) =>
    isOtherCountriesPanel ? (
        <OtherCountriesPanel broadcast={broadcast} description={description} />
    ) : (
        <ListedBroadcaster broadcast={broadcast} />
    );

export default Broadcast;
